import React, { useState, forwardRef, useMemo } from 'react';
import {
    FormControl,
    Select,
    MenuItem,
    ListItemText,
    Typography,
    ListSubheader,
    TextField,
    InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getAllProjects } from 'src/services/projectDetailService';
import { useSelector } from 'react-redux';
import { RootStateType } from 'src/store/RootReducer';
import { GetEmployeeProjectDetails } from 'src/services/projectService';
import { getRmIds } from 'src/services/feedbackService';

interface projectDropdownProps {
    value: string;
    onChange: (e: any) => void;
    disabled?: boolean;
    required?: boolean;
}

const ProjectSelectDropdown = forwardRef((props: projectDropdownProps, _ref) => {
    const [list, setList] = useState([]);
    const [searchText, setSearchText] = useState<string>('');
    const appUser = useSelector((state: RootStateType) => state.appReducer?.user);



    const containsText = (text, searchText) =>
        text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;


    React.useEffect(() => {
        fetchProject();

    }, []);

    const fetchProject = () => {
        if (appUser.Roles.split(',').includes('Super User')) {
            getAllProjects().then((res) => {
                const filteredProjects = res.data;
                const newData = [];

                for (let i = 0; i < filteredProjects.length; i++) {
                    newData.push({
                        projectId: filteredProjects[i]?.id,
                        projectName: filteredProjects[i]?.name,
                        isClosed: filteredProjects[i]?.isClosed,
                    });
                }
                setList(newData.filter(e => !e.isClosed).filter((option) => containsText(option?.projectName, searchText)));
            });
        } else {

            const user = JSON.parse(localStorage.getItem('user') || '{}');
            const userId = user.EmployeeId

            getRmIds().then((response) => {
                if (response.data.data.includes(userId)) {
                    GetEmployeeProjectDetails(appUser?.EmployeeId).then((res) => {
                        let filteredRanges = res?.data;

                                const uniqueProjects = [];
                                const seenProjectNames = new Set();

                                filteredRanges.forEach(item => {
                                if (!seenProjectNames.has(item.projectName)) {
                                    seenProjectNames.add(item.projectName);
                                    uniqueProjects.push(item);
                                }
                                });
                        // let filteredRanges = res?.data.filter(range => {
                        //     const start = new Date(range.startDate);
                        //     const end = new Date(range.endDate);
                        //     return  end >=currentDate && start <=currentDate;
                        // });
                         let newFilteredRanges = uniqueProjects.reduce((acc, item) => {
                            if (!acc.includes(e => e.projectCode === item.projectCode)) {
                                acc.push(item)
                            }
                            return acc;
                        }, []);


                        setList(newFilteredRanges.filter(e => !e.isClosed).filter((option) => containsText(option?.projectName, searchText)));
                    });

                } else {
                    GetEmployeeProjectDetails(appUser?.EmployeeId).then((res) => {
                        const currentDate = new Date();
                        let filteredRanges = res?.data?.filter(range => {
                            const start = new Date(range.startDate);
                            const end = new Date(range.endDate);
                            return currentDate < end && currentDate > start;
                        });

                        let newFilteredRanges = filteredRanges.filter(e => e.role === "Project Manager");
                        newFilteredRanges = newFilteredRanges.reduce((acc, item) => {
                            if (!acc.includes(e => e.projectCode === item.projectCode)) {
                                acc.push(item)
                            }
                            return acc;
                        }, []);

                        setList(newFilteredRanges.filter(e => !e.isClosed).filter((option) => containsText(option?.projectName, searchText)));
                    });
                }
            })

        }
    }



    const filteredLists = useMemo(
        () =>
            list.length > 0 &&
            list?.filter((option) => containsText(option?.projectName, searchText)),
        [list, searchText]
    );

    return (
        <FormControl
            fullWidth
            disabled={props?.disabled ? props?.disabled : false}
            className="task-type-dropdown"
        >
            <Typography fontWeight="light" variant="h5" className="input-lable" pb="0.3rem">
                Select project
            </Typography>
            <Select
                sx={{ mt: '4px' }}
                style={{
                    fontSize: '12px',
                    height: '2rem'
                }}
                displayEmpty
                size="small"
                value={props?.value ? props?.value : ""}
                onChange={(e) => { props?.onChange(e) }
                }
            >
                <MenuItem style={{ display: 'none' }} selected disabled value={''}>
                    Select Project
                </MenuItem>
                <ListSubheader>
                    <TextField
                        id="employee-id"
                        size="small"
                        autoFocus
                        placeholder="Type to search..."
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            )
                        }}
                        onChange={(e) => setSearchText(e.target.value)}
                        onClick={(e) => {
                            e.stopPropagation();
                        }}
                        onKeyDown={(e) => {
                            if (e.key !== 'Escape') {
                                e.stopPropagation();
                            }
                        }}
                    ></TextField>
                </ListSubheader>
                {filteredLists?.length > 0 &&
                    filteredLists.map((type, i) => {
                        return (
                            <MenuItem key={i} value={type.projectId}>
                                <ListItemText primary={type.projectName} />
                            </MenuItem>
                        );
                    })}
            </Select>
        </FormControl>
    );
});

export default ProjectSelectDropdown;
